// jQuery wrapper
(function ($) {

    /**
     ** Document ready
     **/
    $(document).ready(function () {

        $('body').addClass('active');


        // InView - Animate when in viewport (useful for content at top of page)
        $(".animate").on("inview", function (event, isInView) {
            var element = $(this);

            if (isInView) {
                element.addClass("ani-trigger");
            }
        });


        // Smooth Scroll
        $('a.smooth-scroll, button.smooth-scroll').on('click', function (event) {
            event.preventDefault();
            var target = $(this).data('target');
            var headerHeight = $('#site-header').outerHeight();
            var scrollPosition = $(target).offset().top - (headerHeight);
            // var scrollPosition = $(target).offset().top;

            // console.log(headerHeight);

            $('html').animate({
                scrollTop: scrollPosition
            }, 1000);
        });


        // Load & autoplay hero videos on interaction
        let heroVideos = document.querySelector('.onload-iframe');
        if (heroVideos != null) {
            heroAutoplay();
        }


        // Menu - Hamburger
        $('.menu-trigger').click(function (event) {
            event.preventDefault();

            var target = $(this).data('target');

            if ($(this).hasClass('active')) {
                $(this).removeClass('active');
                $(target).remove('active');
                $('#main-menu').removeClass('active');
                $('body').removeClass('menu-open parent-menu-open');
                $('.hasSub > a').removeClass('active');
                $('#main-menu .menu-wrap').removeClass('active');
                $('#main-menu .hasChild > button').removeClass('active');
                $('#main-menu .child-menu').removeClass('active');

            } else {
                $(this).addClass('active');
                $(target).addClass('active');

                $('#main-menu').addClass('active');
                $('body').addClass('menu-open parent-menu-open');
            };
        })


        // Menu - Treatments
        $('.hasSub > a').click(function (event) {
            event.preventDefault();

            var target = $(this).attr('href');

            $('.hasSub > a').removeClass('active');
            $('#main-menu .menu-wrap').removeClass('active');
            $('#main-menu .child-menu').removeClass('active');

            if ($(this).hasClass('active')) {
                $('.menu-trigger').removeClass('active');
                $('#main-menu').removeClass('active');
                $('body').removeClass('menu-open parent-menu-open');

            } else {
                $(this).addClass('active');
                $(target).addClass('active');

                $('.menu-trigger').addClass('active');
                $('#main-menu').addClass('active');
                $('body').addClass('menu-open').removeClass('parent-menu-open');
                $('#main-menu .hasChild > button').removeClass('active');
            }
        });
        // Child Menu
        $('#main-menu .hasChild > button').click(function (event) {
            event.preventDefault();

            var target = $(this).data('target');

            if ($(this).hasClass('active')) {
                $('#main-menu .hasChild > button').removeClass('active');
                $('#main-menu .child-menu').removeClass('active');
            } else {
                $(this).addClass('active');
                $(target).addClass('active');
            }
        });
        // Close Treatment Menu
        $('#main-menu .close').click(function (event) {
            event.preventDefault();

            $('.menu-trigger').removeClass('active');
            $('#main-menu').removeClass('active');
            $('body').removeClass('menu-open parent-menu-open');
            $('#main-menu .menu-wrap').removeClass('active');
            $('#main-menu .hasChild > button').removeClass('active');
            $('#main-menu .child-menu').removeClass('active');
        });
        // Back menu button
        $('#main-menu .back').click(function (event) {
            event.preventDefault();

            var target = $(this).data('target');

            $('#main-menu .menu-wrap').removeClass('active');
            $('#main-menu .hasChild > button').removeClass('active');
            $('#main-menu .child-menu').removeClass('active');
            $(target).addClass('active');
        });


        // Treatment Categories
        if ($('#categories').length > 0) {
            // On hover
            $('#categories .hasSub > a').hover(function () {
                var content = $(this).data('content');
                var image = $(this).data('image');

                $('#categories .hasSub > a, #categories .description, #categories .category-image').removeClass('active');
                $(this).addClass('active');
                $(image).addClass('active');
                $(content).addClass('active');

                $('#categories').removeClass();
                var colour = $(this).data('style');
                $('#categories').addClass(colour);
            },

                // Hover out
                function () {
                    $('#categories .hasSub > a, #categories .description, #categories .category-image').removeClass('active');
                    $('#categories .category-image.default-image').addClass('active');
                    $('#categories').removeClass();
                });
        }

        // Accordion list (FAQ setc.)
        if ($('.accordion-list').length > 0) {
            $('.accordion-list .answer:not(.active)').hide();
            // var allPanels = $('.accordion-list .answer');

            $('.accordion-list .accordion-toggle').click(function () {
                // var targetParent = $(this).data('parent');
                var target = $(this).data('target');

                // console.log(targetParent);

                if ($(target).hasClass('active')) {
                    $(this).removeClass('current');
                    $(target).removeClass('active').slideUp(250);

                } else {
                    $('.accordion-list .accordion-toggle').removeClass('current');
                    $('.accordion-list .answer').removeClass('active').slideUp(250);

                    $(this).addClass('current');
                    $(target).addClass('active').slideDown(250);
                }

                // Prevent default 'link' behaviour
                return false;
            });
        }

        // Video modal toggle open/closed
        $('.video-toggle').click(function () {
            var target = $(this).data('target');
            $(target).modal('toggle');
        });
        // Video modal - Empty player on close	    
        $('.close-video').click(function () {
            $('.video-container').empty();
        });


        // Treatments - Load More
        $('.more-list .load-more').click(function () {
            $('.more-list').toggleClass('show-more');

            if ($('.more-list').hasClass('show-more')) {
                $(this).text('Show less');
            } else {
                $(this).text('Load more');
            }
        });


        // Locations - Filter
        if ($('.location-filter').length > 0) {
            // Filter Toggle (mobile)
            $('.location-filter .filter-toggle').click(function () {
                $('.location-filter .nav').toggleClass('open');
            });

            // Filter Buttons
            $('.location-filter .nav button').click(function () {
                var target = $(this).data('target');

                $('.location-filter .nav').removeClass('open');
                $('.location-filter .nav button').removeClass('active');
                $('.location-item').removeClass('active');

                $(this).addClass('active');
                $(target).addClass('active');
            })
        }

        // Content Filter (Resource Videos, Case Studies)
        if ($('.content-filter').length > 0) {
            // Filtering
            $('.content-filter-toggle').on('click', function () {
                $('.filter-options').toggleClass('active');
                $('.content-filter-toggle').toggleClass('active');
            })

            $('.content-filter .option').on('click', function () {
                var target = $(this).data('target');
                var label = $(this).data('label');

                // Filter from all
                $('.filter-list .filter-item').removeClass('active');
                $(target).addClass('active');
                $('.content-filter-toggle span').text(label);

                // Close options pop-up 
                $('.filter-options').removeClass('active');
                $('.content-filter-toggle').removeClass('active');
            });
        }


        /***
         * Carousels
         ***/
        carouselEqualHeights();

        // Procedure Categories
        if ($('.featured-carousel').length > 0) {
            $('.featured-carousel').slick({
                adaptiveHeight: false,
                slidesToShow: 1,
                slidesToScroll: 1,
                autoplay: false,
                fade: false,
                arrows: true,
                prevArrow: $('.featured-controls .featured-prev'),
                nextArrow: $('.featured-controls .featured-next'),
                infinite: true,
                centerMode: false,
            });

            // Filtering
            $('.featured-filter-toggle').on('click', function () {
                $('.filter-options').toggleClass('active');
                $('.featured-filter-toggle').toggleClass('active');
            })

            $('.featured-filter .option').on('click', function () {
                var target = $(this).data('target');
                var label = $(this).data('label');

                // Unfilter to show all
                $('.featured-carousel').slick('slickUnfilter');
                $('.featured-filter-toggle span').text('All');

                // Filter from all
                $('.featured-carousel').slick('slickFilter', target);
                $('.featured-filter-toggle span').text(label);

                // Close options pop-up 
                $('.filter-options').removeClass('active');
                $('.featured-filter-toggle').removeClass('active');
            });
        }

        // Surgeons
        if ($('.surgeons-carousel').length > 0) {
            $('.surgeons-carousel').slick({
                adaptiveHeight: false,
                slidesToShow: 1,
                slidesToScroll: 1,
                autoplay: false,
                fade: false,
                arrows: true,
                prevArrow: $('.surgeons-controls .surgeons-prev'),
                nextArrow: $('.surgeons-controls .surgeons-next'),
                infinite: true,
                centerMode: false,
            });
        }

        // Videos
        if ($('.videos-carousel').length > 0) {
            $('.videos-carousel').slick({
                adaptiveHeight: false,
                slidesToShow: 1,
                slidesToScroll: 1,
                autoplay: false,
                fade: false,
                arrows: true,
                prevArrow: $('.videos-controls .videos-prev'),
                nextArrow: $('.videos-controls .videos-next'),
                infinite: true,
                centerMode: false,
            });
        }

        // Accreditations (Footer)
        if ($('.accreditation-carousel').length > 0) {
            $('.accreditation-carousel').slick({
                adaptiveHeight: false,
                slidesToShow: 6,
                slidesToScroll: 1,
                autoplay: true,
                autoplaySpeed: 5000,
                fade: false,
                arrows: false,
                infinite: true,
                centerMode: true,
                responsive: [
                    {
                        breakpoint: 992,
                        settings: {
                            slidesToShow: 2,
                            centerMode: false,
                        }
                    },
                ]
            })
        }

        // Before & After Images
        if ($('.results-carousel').length > 0) {
            $('.results-carousel').slick({
                adaptiveHeight: false,
                slidesToShow: 1,
                slidesToScroll: 1,
                autoplay: false,
                fade: false,
                arrows: true,
                prevArrow: $('.results-controls .results-prev'),
                nextArrow: $('.results-controls .results-next'),
                infinite: true,
                centerMode: false,
            });
        }

        // Related News
        if ($('.articles-carousel').length > 0) {
            $('.articles-carousel').slick({
                adaptiveHeight: false,
                slidesToShow: 1,
                slidesToScroll: 1,
                autoplay: false,
                fade: false,
                arrows: true,
                prevArrow: $('.articles-controls .articles-prev'),
                nextArrow: $('.articles-controls .articles-next'),
                infinite: true,
                centerMode: false,
            });
        }



        /*
        // Animate on Scroll
        AOS.init({
            // Global options
            offset: 0,
            duration: 1000,
            easing: 'ease-in-out-sine',
            delay: 300,
            // once: true,
        });
        */
        /*
        // Refresh AOS after all images loaded
        document.querySelectorAll("img").forEach(img => {
            img.addEventListener("load", () => {
                AOS.refresh();
            });
        });
        */


    }); // End Document Ready


    // On load
    $(window).on('load', function () {

        // Header bar scrolled
        scrollbarState();

    });


    // On Scroll
    $(window).on('scroll', function () {

        // Header bar scrolled
        scrollbarState();

    });

    // On Resize
    $(window).on('resize', function () {

        carouselEqualHeights();

    });


    /***
    ** Functions
    ***/

    // Header bar scrolled
    function scrollbarState() {
        // Header bar height
        var navHeight = $('#site-header').outerHeight();

        if ($(document).scrollTop() > navHeight) {
            $('body').addClass('scrolled');
            $('#site-header').addClass('is-scrolled');
        } else {
            $('body').removeClass('scrolled');
            $('#site-header').removeClass('is-scrolled');
        }
    }

    // Hero video autoplay on interaction
    function heroAutoplay() {
        let videoLoaded = false;

        function loadVideo() {
            if (!videoLoaded) {
                document.querySelectorAll('.onload-iframe').forEach(function (iframe) {
                    const baseSrc = iframe.getAttribute('data-src');
                    iframe.setAttribute('src', baseSrc + '&autoplay=1');
                    iframe.classList.add('loaded');
                });
                videoLoaded = true;
                // Remove event listeners after first trigger
                events.forEach(event => {
                    document.removeEventListener(event, loadVideo);
                });
            }
        }

        const events = ['mousemove', 'click', 'keydown', 'touchstart'];
        events.forEach(event => {
            document.addEventListener(event, loadVideo, { once: true });
        });
    }

    // Carousel - Equal heights
    function carouselEqualHeights() {
        $('.carousel.equal').on('setPosition', function () {
            $(this).find('.slick-slide').height('auto');
            var slickTrack = $(this).find('.slick-track');
            var slickTrackHeight = $(slickTrack).height();
            $(this).find('.slick-slide').css('height', slickTrackHeight + 'px');
        });
    }

    // end jQuery wrapper
})(jQuery);